module.exports = __webpack_public_path__ + "img/Mars.b65e0622.svg";